import React from 'react';
import { motion } from 'framer-motion';
import { FiLayers } from 'react-icons/fi';
import { SecureText } from 'components/Elements';
import { ROLES } from 'lib/authorization';

export const TotalTransactions = ({ transactionsCount }) => {
  const formattedCount = Number(transactionsCount).toLocaleString();

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="relative bg-white/10 backdrop-blur-lg border border-white/10 rounded-2xl p-6 shadow-md text-white overflow-hidden"
    >
      {/* Icon + Title */}
      <div className="flex items-center gap-3 mb-2">
        <div className="bg-white/10 p-2 rounded-full">
          <FiLayers size={18} className="text-white" />
        </div>
        <span className="text-sm text-white/60 uppercase tracking-wider">
          Total Transactions
        </span>
      </div>

      {/* Count */}
      <div className="text-3xl font-bold">
        <SecureText
          value={formattedCount}
          allowedRoles={[ROLES.ROOT_USER, ROLES.TRANSACTION_MANAGER]}
          // requiredPermissions={['viewCustomerProfiles']}
          className="text-sm"
        />
      </div>

      {/* Shine overlay */}
      <div className="absolute inset-0 pointer-events-none rounded-2xl bg-gradient-to-br from-white/10 to-transparent opacity-10 blur-sm" />
    </motion.div>
  );
};
